var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCloseWhite(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1 99.4L1.2 86.5l36.4-36.4L1.5 14 14.4 1.1l36.1 36.1L86.6 1.1 99.5 14 63.4 50.1l36.4 36.4-12.9 12.9L50.5 63 14.1 99.4z",
    fill: "#fff"
  })));
}

export default __webpack_public_path__ + "static/media/close-white.71447765493410a3558d0cb4fbed5656.svg";
export { SvgCloseWhite as ReactComponent };